module.exports = __webpack_public_path__ + "img/video2.1d1f8728.svg";